import React from 'react';
import DateFormat from '../../lib.r2/utils/DateFormat';
import Store from '../../store/Store';
import { Inline } from '../ui/Inline';
import { StatusLabel } from '../ui/StatusLabel';

export interface OrderItemData {
	name: string;
	orderId: string;
	orderState: string;
	dateFrom: string;
	dateTo: string;
	mission: string;
	price: number;
	_polyref?: any;
}

export interface OrderItemProps {
	data: OrderItemData;
	onClick: () => void;
	interactive?: boolean;
	hovered?: boolean | undefined;
	noPrice?: boolean | undefined;
	dashboard?: boolean | undefined;
}

export const OrderItem: React.FC<OrderItemProps> = props => {
	return (
		<button
			data-pw="order-item"
			className={
				'order-item' +
				(props.dashboard ? ' order-item-dashboard' : '') +
				(props.data.orderState === 'CANCELED' || props.data.orderState === 'COMPLETED'
					? ' done-card'
					: '')
			}
			onClick={e => {
				console.log((e.target as HTMLElement).className);
				if ((e.target as HTMLElement).className === 'order-item-remove') {
					Store.removeOrder(props.data, Store.mode ?? 'defaultMode');
				} else {
					props.onClick();
				}
			}}
		>
			<Inline>
				<h2 className="text-xl">{props.data.name}</h2>
				{!props.interactive &&
					<StatusLabel>
						{props.data.orderState as 'CANCELED' | 'COMPLETED' | 'AWAITING_PAYMENT' | 'DELAYED' | 'AWAITING_APPROVAL' | 'ONGOING'}
					</StatusLabel>
				}
			</Inline>

			<div className="text-left">
				<span>
					Bestelldatum: {DateFormat(props.data.dateFrom, 'dd.mm.yyyy') + ' - ' + DateFormat(props.data.dateTo, 'dd.mm.yyyy')}
					<br />
					{props.data.mission}
					<br />
				</span>
				{props.noPrice !== true &&
					<span>Preis: €{(props.data.price * 1.2).toFixed(2)}</span>
				}
			</div>
		</button>
	);
};
